export const BASE_API_URL = '___api_url___';
export const APP_TITLE = 'MAX PLANCK - Computer Science Training Platform';
